import { yen } from '@/lib/price'
import { Order } from '~/api-client/data-contracts'

type Props = {
  order: Order | null
}

type DisplayItem = {
  label: string
  amount: number
  role?: string
}

function buildDisplayItems(order: Order): DisplayItem[] {
  const result: DisplayItem[] = []
  const items = order.attributes.display_items

  const branchItem = items.find((item) => item.label.includes('グリーン'))
  branchItem && result.push({ ...branchItem, label: '季節の枝もの定期便（月1回）' })

  const vaseItem = items.find((item) => item.label.includes('花器'))
  vaseItem && result.push({ ...vaseItem, label: 'フラワーベース', amount: vaseItem.amount - order.attributes.product_discount })

  const deliveryFeeItem = items.find((item) => item.label.includes('クール便追加料金'))
  if (deliveryFeeItem) {
    result.push({ ...deliveryFeeItem, label: 'クール便追加料金' })
  } else {
    result.push({ label: '送料', amount: 0, role: 'default' })
  }

  const taxItem = items.find((item) => item.label.includes('消費税'))
  taxItem && result.push({ ...taxItem, label: '消費税（10%）' })

  return result
}

export const PriceTable: React.FC<Props> = ({ order }) => {
  if (!order) return null

  const displayItems = buildDisplayItems(order)

  return (
    <div className="space-y-3 text-[14px]">
      {displayItems.map((item, index) => (
        <div key={index} className="flex justify-between">
          <span className="text-dark-gray">{item.label}</span>
          <span className="text-main">{item.amount === 0 ? '無料' : yen(item.amount)}</span>
        </div>
      ))}
      <div className="flex justify-between pt-4 border-t border-gray/40 font-medium">
        <span className="text-black">合計（税込）</span>
        <span className="text-[18px] text-black">{yen(order.attributes.total)}</span>
      </div>
    </div>
  )
}
